module.exports = __webpack_public_path__ + "static/media/ios-download.617c2bba.svg";